require('./bootstrap');

import Alpine from 'alpinejs';
import FormsAlpinePlugin from '../../vendor/filament/forms/dist/module.esm'
import NotificationsAlpinePlugin from '../../vendor/filament/notifications/dist/module.esm'

Alpine.plugin(FormsAlpinePlugin)
Alpine.plugin(NotificationsAlpinePlugin)


window.Alpine = Alpine;

import ScrollOut from "scroll-out";
window.ScrollOut = ScrollOut;

Alpine.start();



ScrollOut({
    onShown: function (el) {
        // remove the class
        el.classList.add("animate-none");

        // force reflow
        void el.offsetWidth;

        // re-add the animated cl
        el.classList.remove("animate-none");

    },
    onHide: function (el){
        el.classList.add("animate-none");

    }
});
